import React from 'react';
import styled, {css} from 'styled-components';

import {positionTopRight} from '../../../shared-components/mixin/position';
import {colorTheme} from '../../mixin/colorTheme.js';

export const CardBody = styled.div`
    padding: var(--card-padding);
`;
export const CardHeader = styled.div`
    ${colorTheme({
        '--card-header-background': {dark: '#181b1f       ', light: '#EAECF6 '},
    })};

    background: var(--card-header-background);
    padding: var(--space) var(--card-padding);
`;

export const CardActions = ({children, hover}) => (
    <>
        {hover && <CardActionsHoverWrapper hover={hover}>{children}</CardActionsHoverWrapper>}
        {!hover && <CardActionsWrapper>{children}</CardActionsWrapper>}
    </>
);

const CardActionsWrapper = styled.div`
    ${positionTopRight()}
    display: flex;
    gap: var(--space-xsm);
    transform: translate(-8px, -8px);
`;
export const CardActionsHoverWrapper = styled(CardActionsWrapper)`
    ${({hover}) => {
        if (hover)
            return css`
                opacity: 0;
                pointer-events: none;
                right: -12px;
                top: -4px;
            `;
    }}
`;

export const conditionCardSize = ({size}) => {
    if (size === 'sm') {
        return css`
            ${CardBody},
            ${CardHeader} {
                padding: var(--space-sm);
            }
            ${CardBody} ${CardHeader} {
                margin: calc(0px - var(--space-sm)) calc(0px - var(--space-sm)) var(--space-sm);
            }
        `;
    }
};
